import { render, staticRenderFns } from "./choiceUser.vue?vue&type=template&id=8a15e1f2&scoped=true"
import script from "./choiceUser.vue?vue&type=script&lang=js"
export * from "./choiceUser.vue?vue&type=script&lang=js"
import style0 from "./choiceUser.vue?vue&type=style&index=0&id=8a15e1f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a15e1f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a15e1f2')) {
      api.createRecord('8a15e1f2', component.options)
    } else {
      api.reload('8a15e1f2', component.options)
    }
    module.hot.accept("./choiceUser.vue?vue&type=template&id=8a15e1f2&scoped=true", function () {
      api.rerender('8a15e1f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/visitPlan/choiceUser.vue"
export default component.exports